import {SxProps, Theme, Typography} from '@mui/material';
import {FC} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import theme from 'src/theme';
import {useSxValue} from './ColorField.hook';
import {ColorFieldType} from './ColorField.types';
import {pillFitSx, pillShapePhoneSx} from '../pillFit.sx';
import {useFitText} from 'src/hooks/useFitText';

export const ColorField: FC<ColorFieldType> = ({label = 'DRIVER'}) => {
    const intl = useIntl();
    const fitRef = useFitText<HTMLSpanElement>(`${intl.locale}:${label}`);
    const sxValue: SxProps<Theme> = Object.assign({}, useSxValue(label), {
        padding: theme.spacing(3 / 8, 6 / 8),
        borderRadius: theme.spacing(4 / 8),
        fontWeight: 500,
        ...pillFitSx,
        [theme.breakpoints.down('md')]: pillShapePhoneSx,
    });

    const formattedLabel = (label === 'DRIVER' || label === 'PRIVATE_DRIVER') ? 'PRIVATE DRIVER' : label;

    return (
        <Typography
            ref={fitRef}
            sx={sxValue}
            component="span"
        >
            {/* The label is a translation key for the fixed things this badge started with — user
                types, contract statuses — and a plain name for the ones it shows now: roles, which a
                business writes itself and no catalog can hold. Falling back to the label renders
                "CRM Team" as itself instead of reporting a missing translation for every role in the
                list. */}
            <FormattedMessage
                id={formattedLabel}
                defaultMessage={formattedLabel}
            />
        </Typography>
    );
};
